import './style.scss';

import { TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import React from 'react';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

const PREFIX = 'multi-article-container';

@tracker
@inject(getChildInject('initStore', 'modalStore', 'agentStore'))
@observer
export default class MultiArticle extends React.PureComponent {
  @observable beenChoosenList = [];

  static defaultProps = {
    // props
    dialogueId: '',
    msgContent: '',
    articleList: [],
    // stores
    initStore: {},
    modalStore: {},
  };

  constructor(props) {
    super(props);
    const {
      articleList,
      dialogueId,
      initStore,
      nodePointId,
      isHistory,
      historyDialogueId,
      historySessionId,
    } = this.props;

    this.articleGroup = [];
    this.buttonDetails = [];

    articleList.map((article) => {
      this.articleGroup.push(article.article_number);
      this.buttonDetails.push({
        button_type: article.button_type,
        button_id: article.button_id,
        button_text: article.title,
      });
    });

    this.trackingname = TRACKING_TYPE.ARTICLEGROUP;
    this.trackingdata = {
      article_group: this.articleGroup,
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_details: this.buttonDetails,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
  }

  @action
  async pushChoosen(index) {
    !this.beenChoosenList.includes(index) && this.beenChoosenList.push(index);
  }

  componentDidMount() {
    // 判断文章是否有自动弹出，只弹出接口返回的默认弹出第一篇
    const { articleList = [], agentStore, isHistory } = this.props;
    const arr = articleList.filter((item) => {
      return item?.should_display_instantly === true;
    });
    setTimeout(() => {
      if (arr.length > 0 && !isHistory && !agentStore.inAgent) {
        const { modalStore } = this.props;
        const article = arr[0];
        const trackingArticleDetailBasicData = {
          chat_session_id: this.trackingdata.chat_session_id,
          chat_dialogue_id: this.trackingdata.chat_dialogue_id,
          bot_id: Number(article.kb_bot_id),
          intent_id: Number(article.kb_intent_id),
          article_id: article.id,
          article_title: article.title,
        };
        modalStore.UPDATE_MODAL_ARTICLE({
          trackingArticleDetailBasicData,
          isHistory,
          ...article,
        });
        modalStore.SHOW_ARTICLE_MODAL();
      }
    }, 0);
  }

  handleOptionClick = (article, index) => () => {
    const trackingArticleDetailBasicData = {
      chat_session_id: this.trackingdata.chat_session_id,
      chat_dialogue_id: this.trackingdata.chat_dialogue_id,
      bot_id: Number(article.kb_bot_id),
      intent_id: Number(article.kb_intent_id),
      article_id: article.id,
      article_title: article.title,
    };
    // 点击埋点
    this.trackingHandler(article);

    this.pushChoosen(index);
    const { modalStore, isHistory } = this.props;
    modalStore.UPDATE_MODAL_ARTICLE({
      trackingArticleDetailBasicData,
      isHistory,
      ...article,
    });
    modalStore.SHOW_ARTICLE_MODAL();
  };

  // 埋点用 - 点击事件
  trackingHandler = (data) => {
    const { dialogueId, initStore, tracker, nodePointId, isHistory, historyDialogueId, historySessionId } = this.props;

    tracker.click({
      trackingname: this.trackingname,
      data: {
        article_group: this.articleGroup,
        article_id: data.article_number,
        node_point_id: nodePointId,
        chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        button_type: data.button_type,
        button_id: data.button_id,
        button_text: data.title,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      },
    });
  };

  generateArticle = (option, index) => {
    const { msgContent } = this.props;
    const props = {
      className: `option-container${msgContent ? '' : ' no-msg'}${this.beenChoosenList.includes(index) ? ' grey' : ''}`,
      key: `option-${index}`,
      onClick: this.handleOptionClick(option, index),
    };
    return <div {...props}>{option.title}</div>;
  };

  render() {
    const { msgContent, articleList, passedRef } = this.props;
    const trackingdata = JSON.stringify(this.trackingdata);

    return (
      <div className={PREFIX}>
        <Msg content={msgContent} />
        <div className="options" ref={passedRef} data-trackingname={this.trackingname} data-trackingdata={trackingdata}>
          {articleList.map((option, index) => {
            return this.generateArticle(option, index);
          })}
        </div>
      </div>
    );
  }
}
